import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getContent, getDraftContent } from "../lib/api";
import { RecLoader, LoadError } from "../components/site/RecLoader";

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

const isPreview = () => {
  try {
    const p = new URLSearchParams(window.location.search).get("preview") === "1";
    return p && !!localStorage.getItem("karams_admin_token");
  } catch { return false; }
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);
  const preview = isPreview();

  const load = useCallback(async () => {
    setError(false);
    // Resilient initial load: retry with backoff so a transient failure (e.g. during
    // search-engine / prerender rendering) never surfaces the hard LoadError page → avoids Soft 404.
    const delays = [0, 600, 1500, 3000, 5000];
    for (let i = 0; i < delays.length; i++) {
      if (delays[i]) await new Promise((r) => setTimeout(r, delays[i]));
      try {
        if (preview) {
          try { const { data } = await getDraftContent(); setContent(data); return; }
          catch { setContent(await getContent()); return; }
        }
        setContent(await getContent());
        return;
      } catch {
        // keep retrying until attempts are exhausted
      }
    }
    setContent(null);
    setError(true);
  }, [preview]);

  useEffect(() => { load(); }, [load]);

  if (error) return <LoadError onRetry={load} />;
  if (!content) return <RecLoader />;

  return (
    <ContentContext.Provider value={{ content, reload: load, preview }}>
      {preview && (
        <div className="fixed top-0 inset-x-0 z-[10001] bg-electric text-black text-center text-[11px] tracking-[0.2em] uppercase py-1.5 font-semibold" data-testid="preview-banner">
          Aperçu du brouillon — non publié
        </div>
      )}
      {children}
    </ContentContext.Provider>
  );
};
